/* eslint-disable react/no-unused-state */
import React, { Fragment, PureComponent } from 'react';
import PropTypes from 'prop-types';
import ExperimentContext from '../experiment/provider';
import getAssignedBucket from '../services';

export default class Experiment extends PureComponent {
  static contextType = ExperimentContext;

  static propTypes = {
    children: PropTypes.node.isRequired,
    name: PropTypes.string.isRequired,
    defaultBucket: PropTypes.string,
    beforeExperimentBucketAssigned: PropTypes.func,
    afterExperimentBucketAssigned: PropTypes.func,
    environment: PropTypes.string,
    identifier: PropTypes.string,
    apiTimeout: PropTypes.number,
    cacheMinutes: PropTypes.number
  };

  static defaultProps = {
    defaultBucket: 'control',
    beforeExperimentBucketAssigned: null,
    afterExperimentBucketAssigned: null,
    environment: null,
    identifier: null,
    apiTimeout: null,
    cacheMinutes: null
  };

  state = {
    isLoading: true
  };

  async componentDidMount() {
    const {
      name,
      defaultBucket,
      apiTimeout: apiTimeoutOverride,
      cacheMinutes: cacheMinutesOverride,
      environment: environmentOverride,
      identifier: identifierOverride,
      beforeExperimentBucketAssigned: beforeExperimentBucketAssignedOverride,
      afterExperimentBucketAssigned: afterExperimentBucketAssignedOverride
    } = this.props;
    const {
      UpdateAssignedBucketByExperimentName,
      apiTimeout: apiTimeoutDefault,
      cacheMinutes: cacheMinutesDefault,
      environment: environmentDefault,
      identifier: identifierDefault,
      beforeExperimentBucketAssigned: beforeExperimentBucketAssignedDefault,
      afterExperimentBucketAssigned: afterExperimentBucketAssignedDefault
    } = this.context;
    const options = {
      apiTimeout: apiTimeoutOverride || apiTimeoutDefault || 2000,
      cacheMinutes: cacheMinutesOverride || cacheMinutesDefault || 15,
      environment: environmentOverride || environmentDefault || 'production',
      identifier: identifierOverride || identifierDefault
    };
    const beforeExperimentBucketAssigned =
      beforeExperimentBucketAssignedOverride ||
      beforeExperimentBucketAssignedDefault;
    const afterExperimentBucketAssigned =
      afterExperimentBucketAssignedOverride ||
      afterExperimentBucketAssignedDefault;

    if (beforeExperimentBucketAssigned)
      beforeExperimentBucketAssigned({ experimentName: name });

    getAssignedBucket({
      experimentName: name,
      ...options
    }).then(({ assignedBucket }) => {
      const bucketName = assignedBucket || defaultBucket;
      UpdateAssignedBucketByExperimentName({
        bucketName,
        experimentName: name
      });

      if (afterExperimentBucketAssigned)
        afterExperimentBucketAssigned({ experimentName: name, bucketName });
    });
  }

  render() {
    const { children, name } = this.props;
    const { context } = this;

    return (
      <Fragment>
        {typeof children === 'function'
          ? children({ experiment: context.experiments[name] })
          : children}
      </Fragment>
    );
  }
}
